/**
 * Types of supported calendar item droppables
 */
export const enum DroppableType {
    DayWeek = 1,
    AllDay = 2,
    Month = 3,
}
